export default "__VITE_ASSET__BXr6VSNg__"